import { createSlice } from '@reduxjs/toolkit';

// Load auth state from localStorage
const storedAuth = JSON.parse(localStorage.getItem('authState')) || {
  user: null,
  isAuthenticated: false,
  loading: true,
};

const authSlice = createSlice({
  name: 'auth',
  initialState: { storedAuth },
  reducers: {
    loginSuccess: (state, action) => {
      state.user = action.payload.user;
      state.isAuthenticated = true;
      state.loading = false;

      //localStorage.setItem('authState', JSON.stringify(state)); // ✅ Store entire state
      localStorage.setItem('token', action.payload.token); // ✅ Store token separately
    },
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.loading = false;

      localStorage.removeItem('authState'); // ✅ Remove state
      localStorage.removeItem('token'); // ✅ Remove token
    },
    setAuthState: (state, action) => {
      state.user = action.payload.user;
      state.isAuthenticated = action.payload.isAuthenticated;
      state.loading = false;

      //localStorage.setItem('authState', JSON.stringify(state)); // ✅ Store entire state
      //localStorage.setItem('token', action.payload.token); // ✅ Store token separately
    },
    updateSavedPrompt: (state, action) => {
      const updatedPrompt = action.payload.data;

      const promptIndex = state.user.preferences.prompts.findIndex(
        (prompt) => prompt.id === updatedPrompt.id,
      );

      if (promptIndex !== -1) {
        state.user.preferences.prompts[promptIndex] = updatedPrompt;
      }
    },
    insertSavedPrompt: (state, action) => {
      const newPrompt = action.payload.data;
      state.user.preferences.prompts.push(newPrompt);
    },
    deleteSavedPrompt: (state, action) => {
      const deletedPromptId = action.payload;
      // Locate the state.preferences.prompts array and remove the prompt with the id of deletedPromptId
      state.user.preferences.prompts = state.user.preferences.prompts.filter(
        (prompt) => prompt.id !== deletedPromptId,
      );
    },
    updateUserProfileInfo: (state, action) => {
      const updatedProfile = action.payload;
      //state.user = updatedProfile;
    },
  },
});

export const {
  loginSuccess,
  logout,
  setAuthState,
  updateSavedPrompt,
  insertSavedPrompt,
  deleteSavedPrompt,
  updateUserProfileInfo
} = authSlice.actions;
export default authSlice.reducer;
